import {securityByLevelRequest} from './highSecurityRequest';

const activatingPermissionRequest = (accountPermission, rolePermission, action, method, ...args) => {
    return securityByLevelRequest(accountPermission, rolePermission, true, action, method, ...args);
};

export default activatingPermissionRequest;